@if (documentForm) {
  <form [formGroup]="documentForm" autocomplete="off" novalidate (ngSubmit)="update()">
    <app-slide-over [backdropBlur]="true" [collabsibleSlideover]="true">
      @if (contentType && downloadUrl) {
        <app-center-content>
          @if (contentType === 'application/pdf') {
            <pdf-viewer
              class="h-full"
              [src]="downloadUrl"
              [original-size]="false"
              [zoom-scale]="'page-fit'"
              [autoresize]="true"
            ></pdf-viewer>
          }
          @if (contentType.startsWith('image/')) {
            <div class="w-full h-full flex items-center justify-center">
              <img [src]="downloadUrl" alt="Image Preview" />
            </div>
          }
        </app-center-content>
      }
      <app-slide-over-header
        #headerComponent
        (closeSlideOver)="closeSlideOver()"
        [title]="document.data.name"
        [leadText]="document.id"
        [formDirty]="documentForm.dirty"
      >
        <div class="flex justify-end gap-4">
          <button
            type="button"
            class="text-blue-200 dark:text-blue-300 hover:text-white transition ease-in-out duration-150"
            (click)="downloadDocument()"
          >
            <app-ng-icon class="text-2xl" name="heroDocumentArrowDown"> </app-ng-icon>
          </button>
        </div>
      </app-slide-over-header>
      <app-slide-over-content>
        <app-tab-group class="flex flex-col h-full px-4">
          <ng-template appTab="Dokument">
            @if (hasAiSuggestions()) {
              <div class="mb-6">
                <button
                  type="button"
                  class="w-full flex items-center justify-between p-3 bg-blue-50 dark:bg-blue-950 rounded-t-md border border-blue-100 dark:border-blue-900"
                  (click)="isAiPanelOpen = !isAiPanelOpen"
                >
                  <span class="flex items-center gap-2">
                    <app-ng-icon name="heroSparkles" class="text-blue-400 dark:text-blue-300"></app-ng-icon>
                    <span class="font-medium text-blue-700 dark:text-blue-300">AI Vorschläge</span>
                  </span>
                  <app-ng-icon
                    [name]="isAiPanelOpen ? 'heroChevronUp' : 'heroChevronDown'"
                    class="text-blue-400 dark:text-blue-300"
                  ></app-ng-icon>
                </button>
                @if (isAiPanelOpen) {
                  <div class="border border-t-0 dark:border-blue-900 rounded-b-md p-4 space-y-4">
                    <!-- Name -->
                    @if (document.data.documentAI?.raw?.document_name) {
                      <div class="flex items-center justify-between">
                        <div class="flex-1">
                          <div class="text-sm text-fg-secondary">Name</div>
                          <div class="font-medium text-fg-primary">
                            {{ document.data.documentAI?.raw?.document_name }}
                          </div>
                        </div>
                        <button
                          type="button"
                          class="ml-4 text-primary hover:text-blue-700 dark:hover:text-blue-400 text-sm font-medium"
                          (click)="
                            applyAiSuggestion('name', document.data.documentAI?.raw?.document_name)
                          "
                        >
                          Übernehmen
                        </button>
                      </div>
                    }
                    <!-- Description -->
                    @if (document.data.documentAI?.raw?.document_description) {
                      <div class="flex items-center justify-between">
                        <div class="flex-1">
                          <div class="text-sm text-fg-secondary">Notizen</div>
                          <div class="font-medium text-fg-primary">
                            {{ document.data.documentAI?.raw?.document_description }}
                          </div>
                        </div>
                        <button
                          type="button"
                          class="ml-4 text-primary hover:text-blue-700 dark:hover:text-blue-400 text-sm font-medium"
                          (click)="
                            applyAiSuggestion(
                              'comment',
                              document.data.documentAI?.raw?.document_description
                            )
                          "
                        >
                          Übernehmen
                        </button>
                      </div>
                    }
                    <!-- Date -->
                    @if (document.data.documentAI?.raw?.document_date) {
                      <div class="flex items-center justify-between">
                        <div class="flex-1">
                          <div class="text-sm text-fg-secondary">Datum</div>
                          <div class="font-medium text-fg-primary">
                            {{ document.data.documentAI?.raw?.document_date | date: 'dd.MM.yyyy' }}
                          </div>
                        </div>
                        <button
                          type="button"
                          class="ml-4 text-primary hover:text-blue-700 dark:hover:text-blue-400 text-sm font-medium"
                          (click)="
                            applyAiSuggestion(
                              'documentDate',
                              document.data.documentAI?.raw?.document_date
                            )
                          "
                        >
                          Übernehmen
                        </button>
                      </div>
                    }
                    <!-- Amount -->
                    @if (document.data.documentAI?.raw?.total_amount) {
                      <div class="flex items-center justify-between">
                        <div class="flex-1">
                          <div class="text-sm text-fg-secondary">Betrag</div>
                          <div class="font-medium text-fg-primary">
                            {{ document.data.documentAI?.raw?.total_amount | number: '1.2-2' }} CHF
                          </div>
                        </div>
                        <button
                          type="button"
                          class="ml-4 text-primary hover:text-blue-700 dark:hover:text-blue-400 text-sm font-medium"
                          (click)="
                            applyAiSuggestion('amount', document.data.documentAI?.raw?.total_amount)
                          "
                        >
                          Übernehmen
                        </button>
                      </div>
                    }
                    <!-- Due Date -->
                    @if (document.data.documentAI?.raw?.due_date) {
                      <div class="flex items-center justify-between">
                        <div class="flex-1">
                          <div class="text-sm text-fg-secondary">Valuta</div>
                          <div class="font-medium text-fg-primary">
                            {{ document.data.documentAI?.raw?.due_date | date: 'dd.MM.yyyy' }}
                          </div>
                        </div>
                        <button
                          type="button"
                          class="ml-4 text-primary hover:text-blue-700 dark:hover:text-blue-400 text-sm font-medium"
                          (click)="
                            applyAiSuggestion('valueDate', document.data.documentAI?.raw?.due_date)
                          "
                        >
                          Übernehmen
                        </button>
                      </div>
                    }
                    <!-- Supplier -->
                    @if (document.data.documentAI?.raw?.supplier_name) {
                      <div class="flex items-center justify-between">
                        <div class="flex-1">
                          <div class="text-sm text-fg-secondary">Kunde</div>
                          <div class="font-medium text-fg-primary">
                            {{ document.data.documentAI?.raw?.supplier_name }}
                          </div>
                        </div>
                        <button
                          type="button"
                          class="ml-4 text-primary hover:text-blue-700 dark:hover:text-blue-400 text-sm font-medium"
                          (click)="createCustomer(document.data.documentAI?.raw?.supplier_name)"
                        >
                          Anlegen
                        </button>
                      </div>
                    }
                  </div>
                }
              </div>
            }
            @if (!downloadUrl) {
              <div class="rounded-md bg-red-50 mt-4 p-4">
                <div class="flex">
                  <div class="flex-shrink-0">
                    <app-ng-icon class="text-lg text-red-400" name="heroXCircleSolid"></app-ng-icon>
                  </div>
                  <div class="ml-3">
                    <h3 class="text-sm font-medium text-red-800">
                      Dokument konnte nicht geladen werden.
                    </h3>
                  </div>
                </div>
              </div>
            }
            @if (isInternalInvoice) {
              <div class="rounded-md bg-surface p-4 mt-4 shadow-md">
                <div class="flex">
                  <div class="flex-shrink-0">
                    <app-ng-icon class="text-lg text-fg-faint" name="heroExclamationTriangleSolid">
                    </app-ng-icon>
                  </div>
                  <div class="ml-3">
                    <h3 class="text-sm font-medium text-fg-subtle">Jessie.ai erzeugte Rechnung</h3>
                    <div class="mt-2 text-sm text-fg-subtle">
                      <p>Dieses Dokument wurde von jessie.ai erzeugt.</p>
                    </div>
                  </div>
                </div>
              </div>
            }
            <div class="divide-y divide-separator overflow-y-auto h-full py-5">
              <div class="space-y-6 pb-5">
                <app-input class="mt-4">
                  <app-toggle-button-group formControlName="type">
                    <app-toggle-button value="revenue">Einnahme</app-toggle-button
                    ><app-toggle-button value="expense">Ausgabe</app-toggle-button
                    ><app-toggle-button value="other"
                      >Andere</app-toggle-button
                    ></app-toggle-button-group
                  >
                </app-input>
                <div class="space-y-1">
                  <app-text-input
                    label="Name"
                    class="mt-4"
                    [formControl]="$any(documentForm.controls).name"
                  ></app-text-input>
                </div>
                <div class="space-y-1">
                  <app-text-input
                    label="Notizen"
                    class="mt-4"
                    [formControl]="$any(documentForm.controls).comment"
                  >
                  </app-text-input>
                </div>
                <app-date-input
                  *appHideWhenNotInRole="['owner', 'standard']"
                  label="Datum"
                  class="mt-4"
                  [formControl]="$any(documentForm.controls).documentDate"
                >
                </app-date-input>
              </div>
              @if (showPaymentFields) {
                <div class="flex flex-col space-y-3 pt-6 pb-5">
                  <app-number-input
                    variant="currency"
                    label="Betrag"
                    [formControl]="$any(documentForm.controls).amount"
                  >
                  </app-number-input>
                  <app-date-input
                    label="Valuta"
                    [formControl]="$any(documentForm.controls).valueDate"
                  >
                  </app-date-input>
                  <app-input
                    label="Geschäftsjahr"
                    [errors]="
                      documentForm.get('financialYear')?.touched
                        ? documentForm.get('financialYear')?.errors
                        : null
                    "
                  >
                    <input
                      appTailwindInput
                      formControlName="financialYear"
                      type="number"
                      min="2000"
                      max="2099"
                      step="1"
                    />
                  </app-input>
                  <app-input label="Kategorie">
                    <ng-select
                      [items]="categories | async"
                      bindLabel="displayName"
                      [clearable]="false"
                      [formControlName]="'category'"
                    >
                    </ng-select>
                  </app-input>
                  <div class="relative flex items-start">
                    <div class="flex items-center h-5">
                      <input
                        id="paid"
                        type="checkbox"
                        formControlName="paid"
                        class="focus:ring-blue-500 h-4 w-4 text-blue-600 border-edge rounded disabled:bg-surface-disabled disabled:checked:bg-blue-400"
                      />
                    </div>
                    <div class="ml-3 text-sm">
                      <label for="paid" class="font-medium text-fg-subtle">Bezahlt</label>
                    </div>
                  </div>
                </div>
              }
              <div class="space-y-6 pt-6 pb-5">
                <app-input label="Kunde">
                  <ng-select
                    [items]="customers$ | async"
                    bindLabel="data.displayName"
                    bindValue="id"
                    formControlName="customer"
                  >
                    <ng-template ng-footer-tmp let-searchTerm="searchTerm">
                      <div class="mx-4 my-2 truncate">
                        @if (searchTerm) {
                          <button
                            appTailwindButton
                            type="button"
                            size="xs"
                            (click)="createCustomer(searchTerm)"
                            class="truncate"
                          >
                            Kunde
                            {{
                              searchTerm.length > 23
                                ? searchTerm.substring(0, 20) + '...'
                                : searchTerm
                            }}
                            anlegen
                          </button>
                        }
                      </div>
                    </ng-template>
                  </ng-select>
                </app-input>
                @if (recognizedCompanyNotFound) {
                  <div class="relative rounded-md bg-yellow-50 p-4 mt-4 shadow-xl">
                    <div class="flex">
                      <div class="flex-shrink-0">
                        <app-ng-icon
                          class="text-xl text-yellow-400"
                          name="heroExclamationTriangleSolid"
                        ></app-ng-icon>
                      </div>
                      <div class="ml-3">
                        <h3 class="text-sm font-medium text-yellow-800">
                          Kundenname nicht gefunden
                        </h3>
                        <div class="mt-2 text-sm text-yellow-700">
                          <p>
                            Es wurde kein Kunde mit den Namen
                            <b>{{ document.data.documentAI?.curated?.supplier_short_name }}</b>
                            gefunden. Soll ein solcher angelegt werden?
                          </p>
                        </div>
                        <div class="mt-4">
                          <div class="-mx-2 -my-1.5 flex">
                            <button
                              type="button"
                              (click)="
                                createCustomer(
                                  document.data.documentAI?.curated?.supplier_short_name ?? ''
                                )
                              "
                              class="rounded-md bg-yellow-50 px-2 py-1.5 text-sm font-medium text-yellow-800 hover:bg-yellow-100 focus:outline-none focus:ring-2 focus:ring-yellow-600 focus:ring-offset-2 focus:ring-offset-green-50"
                            >
                              Kunde anlegen
                            </button>
                            <button
                              type="button"
                              (click)="recognizedCompanyNotFound = false"
                              class="ml-3 rounded-md bg-yellow-50 px-2 py-1.5 text-sm font-medium text-yellow-800 hover:bg-yellow-100 focus:outline-none focus:ring-2 focus:ring-yellow-600 focus:ring-offset-2 focus:ring-offset-green-50"
                            >
                              Nein Danke
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="pointer-events-none absolute inset-y-0 right-0 -mr-[22px] flex items-center text-fg-muted"
                    >
                      <app-ng-icon class="text-fg-muted" name="heroSparkles"></app-ng-icon>
                    </div>
                  </div>
                }
              </div>
              <div class="space-y-6 pt-6 pb-5">
                <div
                  class="relative flex items-start"
                  *appHideWhenNotInRole="['owner', 'standard']"
                >
                  <div class="flex items-center h-5">
                    <input
                      id="accountRelevant"
                      type="checkbox"
                      formControlName="accountRelevant"
                      class="focus:ring-blue-500 h-4 w-4 text-blue-600 border-edge rounded"
                    />
                  </div>
                  <div class="ml-3 text-sm">
                    <label for="accountRelevant" class="font-medium text-fg-subtle"
                      >Buchhaltungsrelevant</label
                    >
                    <p class="text-fg-secondary">Dokument wird für die Buchhaltung freigeben.</p>
                  </div>
                </div>
                @if (!!documentForm.get('accountRelevant')?.value) {
                  <div class="relative flex items-start">
                    <div class="flex items-center h-5">
                      <input
                        id="accountProcessed"
                        type="checkbox"
                        formControlName="accountProcessed"
                        class="focus:ring-blue-500 h-4 w-4 text-blue-600 border-edge rounded"
                      />
                    </div>
                    <div class="ml-3 text-sm">
                      <label for="accountProcessed" class="font-medium text-fg-subtle"
                        >Dokument eingearbeitet</label
                      >
                      <p class="text-fg-secondary">
                        Dokument wurde durch die Buchhaltung eingearbeitet.
                      </p>
                    </div>
                  </div>
                }
                <div
                  class="relative flex items-start"
                  *appHideWhenNotInRole="['owner', 'standard']"
                >
                  <div class="flex items-center h-5">
                    <input
                      id="archived"
                      type="checkbox"
                      formControlName="archived"
                      class="focus:ring-blue-500 h-4 w-4 text-blue-600 border-edge rounded"
                    />
                  </div>
                  <div class="flex flex-row justify-between w-full">
                    <div class="ml-3 text-sm w-1/2">
                      <label for="archived" class="font-medium text-fg-subtle">Archiviert</label>
                      <p class="text-fg-secondary">Dokument wird ins Archiv verschoben.</p>
                    </div>
                    @if (documentForm.get('archived')?.value) {
                      <ng-select
                        class="w-1/2"
                        [items]="archiveFolder$ | async"
                        bindLabel="name"
                        [clearable]="false"
                        bindValue="id"
                        [formControlName]="'archiveFolder'"
                      >
                      </ng-select>
                    }
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
          <ng-container *appHideWhenNotInPlan="['business', 'enterprise']">
            <ng-template appTab="Kommentare" *appHideWhenNotInRole="['owner', 'standard']">
              <app-comment-section
                [parentEntity]="document"
                parentEntityType="document"
                class="block w-full h-full pt-4"
                padded
              >
              </app-comment-section
            ></ng-template>
          </ng-container>
          <ng-container *appHideWhenNotInPlan="['business', 'enterprise']">
            <ng-template appTab="Änderungen" *appHideWhenNotInRole="['owner', 'standard']">
              <app-history
                [forId]="document.id"
                noCard
                class="block h-full overflow-auto my-5"
              ></app-history
            ></ng-template>
          </ng-container>
        </app-tab-group>
      </app-slide-over-content>
      <app-slide-over-footer>
        @if (!isInternalInvoice) {
          <app-dropdown-minimal-menu>
            <app-dropdown-button
              ><app-ng-icon class="text-xl" name="heroTrash"></app-ng-icon
            ></app-dropdown-button>
            <app-dropdown-item (menuClick)="deleteDocument()"> Löschen </app-dropdown-item>
          </app-dropdown-minimal-menu>
        }
        <span class="inline-flex rounded-md shadow-sm">
          <button
            appTailwindButton
            color="secondary"
            type="button"
            (click)="headerComponent.closeSlideOverClicked()"
          >
            Abbrechen
          </button>
        </span>
        <span class="inline-flex rounded-md shadow-sm">
          <button appTailwindButton type="submit">
            {{
              numberOfDocuments > 1 ? currentDocumentIndex + 1 + '/' + numberOfDocuments + ' ' : ''
            }}Speichern
          </button>
        </span>
      </app-slide-over-footer>
    </app-slide-over>
  </form>
}
